module.exports = __webpack_public_path__ + "static/media/1POLICY13.102653d9.jpg";